import React, { PropTypes } from 'react'

import classnames from 'classnames'

import styles from './Table.scss'

const Table = ({ children, className }) => {
  return (
    <table className={classnames(styles.base, styles.table, className)}>
      {children}
    </table>
  )
}

Table.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

export default Table



// WEBPACK FOOTER //
// ./src/components/Table/Table.js